/*
 * @Descripttion: 
 * @Author: Rul
 * @Date: 2020-04-13 10:53:28
 * @LastEditors: hexujie
 * @LastEditTime: 2025-10-31 18:01:59
 */ 
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../routers/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/cash',
    name: 'cash',
    component: () => import('../routers/cash.vue'),
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import('../routers/detailList.vue'),
  },
  {
    path: '/zhuli',
    name: 'zhuli',
    component: () => import('../routers/zhuli.vue'),
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('../routers/test.vue'),
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes,
})

export default router
